import { FC } from 'react';
import { NavContainer, NavItem } from './styles';

export type NavOption = {
  label: string;
  value: string;
}

type HorizontalNavProps = {
  options: NavOption[];
  value: NavOption;
  onSelect: (option: NavOption) => void;
}

export const HorizontalNav: FC<HorizontalNavProps> = ({
  options,
  value,
  onSelect,
}) => (
  <NavContainer>
    {options.map((option) => (
      <NavItem
        key={option.value}
        isActive={value.value === option.value}
        onClick={() => onSelect(option)}
      >
        {option.label}
      </NavItem>
    ))}
  </NavContainer>
);
